import { getCsrfValue } from "../../api/ApiHelper";

import { type MyAccountValues } from "../myAccountTypes";
import { resolveApiUrl } from "../../utils/url/urlResolver";
import { AFFILIATE_FORM_KEY } from "~/feature/Affiliate/AffiliateFormSection";

interface MyAccountPostData extends MyAccountValues {
  newsletterOne: boolean;
  isEnableFieldsTraining?: boolean;
  isPlusUser?: boolean;
}

const apiUrl = resolveApiUrl("/my-account/update");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const editMyAccount = (data: MyAccountPostData): Promise<any> => {
  const isPreferredSalesPartner = !!data[AFFILIATE_FORM_KEY]?.id;
  const commonData = {
    email: data.email,
    firstName: data.firstName,
    lastName: data.lastName,
    newPassword: data.newPassword,
    oldPassword: data.oldPassword,
    company: data.company,
    industrySector: data.industrySector,
    jobTitle: data.jobTitle,
    functionalArea: data.functionalArea,
    line1: data.address,
    line2: data.addressAdditional,
    zipCode: data.zipCode,
    city: data.city,
    country: data.country,
    phone: data.phone,
    salutationCode: data.salutation,
    titleCode: data.title,
    newsletterOne: data.newsletterOne,
    privacyPolicy: data.privacyPolicy,
    isPreferredSalesPartner: isPreferredSalesPartner,
    affiliateId: isPreferredSalesPartner ? data[AFFILIATE_FORM_KEY]?.id ?? undefined : undefined,
    subsidiary: isPreferredSalesPartner ? data[AFFILIATE_FORM_KEY]?.subsidiary ?? undefined : undefined,
    lmsRequest: data.isEnableFieldsTraining,
  };
  const bodyData = !data.isEnableFieldsTraining
    ? !data.isPlusUser
      ? {
          email: data.email,
          firstName: data.firstName,
          lastName: data.lastName,
          newPassword: data.newPassword,
          oldPassword: data.oldPassword,
          salutationCode: data.salutation,
          titleCode: data.title,
          jobTitle: data.jobTitle,
          functionalArea: data.functionalArea,
          lmsRequest: data.isEnableFieldsTraining,
          newsletterOne: data.newsletterOne,
        }
      : {
          ...commonData,
        }
    : {
        ...commonData,
        customerCategoryCode: data.customerCategory,
        knowledgeAreaCode: data.knowledgeArea,
        languageIsoCode: data.language,
        vatNumber: data.vat,
      };
  return fetch(apiUrl, {
    body: JSON.stringify(bodyData),
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    method: "PUT",
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  }).then((response) => {
    if (!response.ok) {
      throw alert("Error status: " + response.status + ", please try again");
    } else {
      return response.json();
    }
  });
};
